// extracted by mini-css-extract-plugin
export var header = "header__P1y28";
export var closeIcon = "close-icon__zkyYy";
export var title = "title__Ek9Hl";